<div [ngClass]="{'expanded small':expanded_form && navService.sidenavSmall,'expanded big':expanded_form && !navService.sidenavSmall,'normal':!expanded_form}">

  <div class="float-button" *ngIf="floatMenu">
    <div class="button">
      <button nz-button nzType="text" (click)="return()" nz-tooltip="Voltar" [hidden]="editMode">
        <nz-icon nzType="enter"></nz-icon>
      </button>
    </div>
    <nz-divider nzType="vertical"></nz-divider>
    <div class="button">
      <button nz-button nzType="text" (click)="expand()" *ngIf="!expanded_form" [nz-tooltip]="'fullScreen'|translateTA">
        <nz-icon nzType="fullscreen"></nz-icon>
      </button>
    </div>
    <div class="button">
      <button nz-button nzType="text" (click)="retract()" *ngIf="expanded_form" [nz-tooltip]="'normalScreen'|translateTA">
        <nz-icon nzType="fullscreen-exit"></nz-icon>
      </button>
    </div>
    <nz-divider nzType="vertical"></nz-divider>
    <div class="button">
      <button nz-button nzType="primary" nzShape="circle" [nz-tooltip]="'save'|translateTA" (click)="salvar()" [disabled]="disabled" *ngIf="mode!='wizard'" [hidden]="editMode">
        <nz-icon nzType="check"></nz-icon>
      </button>
    </div>

  </div>
  <nz-spin class="form-spin" [nzSpinning]="formLoading" nzSize="large">
  <div class="view-component-title" *ngIf="!floatMenu">
    <button nz-button nzType="text" (click)="return()" nz-tooltip="Voltar" [hidden]="editMode">
      <nz-icon nzType="enter"></nz-icon>
    </button>
    <nz-divider nzType="vertical" [hidden]="editMode"></nz-divider>
    <button nz-button nzType="text" (click)="expand()" *ngIf="!expanded_form" [hidden]="editMode" [nz-tooltip]="'fullScreen'|translateTA">
      <nz-icon nzType="fullscreen"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="retract()" *ngIf="expanded_form" [hidden]="editMode" [nz-tooltip]="'normalScreen'|translateTA">
      <nz-icon nzType="fullscreen-exit"></nz-icon>
    </button>
    <div class="flex-spacer" *ngIf="mode=='wizard'"  [hidden]="editMode"></div>
    <button nz-button nzType="primary" nzShape="circle" [nz-tooltip]="'save'|translateTA" (click)="salvar()" [disabled]="disabled" *ngIf="mode!='wizard'" [hidden]="editMode">
      <nz-icon nzType="check"></nz-icon>
    </button>
    <div class="step-wizard-btn" *ngIf="mode=='wizard'"  [hidden]="editMode">
      <span><button nz-button (click)="goBack()" [disabled]="checkStep('B')">{{'back'|translateTA}}</button></span>
      <span class="span10"></span>
      <span><button nz-button nzType="primary" (click)="goForward()" [disabled]="checkStep('A')">{{'next'|translateTA}}</button></span>
      <span class="span10"></span>
      <span><button nz-button nzType="primary" (click)="salvar()">{{'save'|translateTA}}</button></span>
    </div>
    <div class="flex-spacer"></div>
    <div class="space" [hidden]="editMode">
      <button *ngIf="actionList.length > 0" nz-button nzType="primary" nzShape="circle" nz-dropdown [nzDropdownMenu]="menuAction" [nz-tooltip]="'action'|translateTA">
        <nz-icon nzType="more"></nz-icon>
      </button>
      <nz-dropdown-menu #menuAction="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item *ngFor="let mainItem of actionList" (click)="callCustomAction(mainItem,$event)">
            <generic-icon [iconName]="mainItem.ICON" type="google"></generic-icon>
            <span class="menu-label">{{mainItem.NAME}}</span>
          </li>
        </ul>
      </nz-dropdown-menu>
  </div>
  <div class="space">
    <button nz-button nzType="primary" nzShape="circle" [nz-tooltip]="'refresh'|translateTA" (click)="refresh()" [hidden]="editMode">
        <nz-icon nzType="reload"></nz-icon>
    </button>
  </div>
    <div class="config">
      <button nz-button nzType="primary" nzShape="circle" nz-dropdown [nzDropdownMenu]="menuTools" [hidden]="editMode || designMode" [nz-tooltip]="'tools'|translateTA">
        <generic-icon [iconName]="icon" type="google"></generic-icon>
      </button>
      <nz-dropdown-menu #menuTools="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="click($event)">
            <nz-icon nzType="edit"></nz-icon>
            <span class="menu-label">{{'editmode.editmode'|translateTA}}</span>
          </li>
          <li nz-menu-item (click)="clickDesenho($event)">
            <nz-icon nzType="table"></nz-icon>
            <span class="menu-label">{{'editmode.drawmode'|translateTA}}</span>
          </li>
        </ul>
      </nz-dropdown-menu>
      <label class="switch-label" [hidden]="!editMode" [nz-tooltip]="'menuVoadorTooltip'|translateTA">
        <nz-switch [(ngModel)]="floatMenu"></nz-switch>
        <span>{{'menuVoador'|translateTA}}</span>
      </label>
      <nz-divider nzType="vertical" [hidden]="!editMode"></nz-divider>
      <label class="switch-label" [hidden]="!editMode" [nz-tooltip]="'abrirPopupTooltip'|translateTA">
        <nz-switch [(ngModel)]="openPopup"></nz-switch>
        <span>{{'abrirPopup'|translateTA}}</span>
      </label>
      <nz-divider nzType="vertical" [hidden]="!editMode"></nz-divider>
      <label class="switch-label" [hidden]="!editMode" [nz-tooltip]="'naoCarregarTooltip'|translateTA">
        <nz-switch [(ngModel)]="nodata"></nz-switch>
        <span>{{'naoCarregar'|translateTA}}</span>
      </label>
      <nz-divider nzType="vertical" [hidden]="!editMode"></nz-divider>
      <nz-radio-group aria-label="Selecionar uma opção" [(ngModel)]="mode" [hidden]="!editMode" class="radio-selection">
        <label nz-radio nzValue="wizard">{{'editmode.wizard'|translateTA}}</label>
        <label nz-radio nzValue="classic">{{'editmode.classic'|translateTA}}</label>
        <label nz-radio nzValue="step">{{'editmode.vertical'|translateTA}}</label>
      </nz-radio-group>
      <nz-divider nzType="vertical" [hidden]="!editMode"></nz-divider>
      <button nz-button nzType="primary" nzShape="circle" (click)="copyConfiguration()" [hidden]="!editMode" [nz-tooltip]="'editmode.copyconfig'|translateTA">
        <nz-icon nzType="copy"></nz-icon>
      </button>
      <button nz-button nzType="primary" nzShape="circle" (click)="restoreConfiguration()" [hidden]="!editMode" [nz-tooltip]="'editmode.restorconfig'|translateTA">
        <nz-icon nzType="history"></nz-icon>
      </button>
      <button nz-button nzType="primary" nzShape="circle" (click)="addTab()" [hidden]="!editMode" [nz-tooltip]="'editmode.addstep'|translateTA">
        <nz-icon nzType="plus-square"></nz-icon>
      </button>
      <nz-divider nzType="vertical" [hidden]="!editMode"></nz-divider>
      <button nz-button nzType="primary" nzShape="circle" (click)="saveInfo()" [hidden]="!editMode && !designMode" [nz-tooltip]="'save'|translateTA">
        <nz-icon nzType="check"></nz-icon>
      </button>
      <button nz-button nzType="primary" nzDanger nzShape="circle" (click)="cancelEdit()" [hidden]="!editMode && !designMode" [nz-tooltip]="'cancel'|translateTA">
        <nz-icon nzType="close"></nz-icon>
      </button>
    </div>
  </div>
  <div class="editform" *ngIf="!editMode">
    <div class="suspended-menu" cdkDrag *ngIf="showMulti">
      <div class="suspended-menu-actions" cdkDragHandle>
        <span>{{'editmode.availablefields'|translateTA}}</span>
        <span class="flex-spacer" id="aaa"></span>
        <div class="suspended-menu-actions-in">
          <nz-icon nzType="down" [@indicatorRotate]="expanded ? 'expanded': 'collapsed'" (click)="expanded=!expanded"></nz-icon>
        </div>
      </div>
      <div *ngIf="expanded" [@listAnimation] class="suspended-menu-list">
          <div class="suspended-menu-box" *ngFor="let item of dataMultiTableConfig"  draggable="true" [attr.data-drag-data]="'{@MULTI_'+item.columnName+'}'" (dragstart)="drag($event)">{{item.columnDesc}}</div>
      </div>
    </div>
    <nz-tabs *ngIf="!editMode && mode=='classic'" (nzSelectedIndexChange)="changeTab()">
      <nz-tab *ngFor="let item of tabs|arrayFilter:'active':'true':false:true" [nzTitle]="item.customName|translateTA">
        <ng-container *ngIf="getCustomTab(item)">
          <gridster [options]="getTab(item).options" [ngStyle]="editMode ? {'background':'gray','width':'100%', 'height':'100%'  } : {'width':'100%', 'height':'100%'  }">
            <ng-container *ngFor="let col of tableInformation">
              <gridster-item   [item]="col"  *ngIf="col.visible && col.tab==item.customName"  style="height: 68px;">
                <div class="form-field-density-4 full">
                  <ng-container   #viewContainer2 dynamicField (editEventEmmiter)="eventEdit($event)" [config]="col" [group]="formGroup"  [arrayColumnsDef]="tableInformation" [isDynamicform]="false" [row]="row" [entityName]="entityName" [tabindex]="calculateTabInde(col)" [condition]="col.REFEXPRESSION" [entityDesc]="entityDesc" [canConfig]="canConfig" [evento]="evento">
                  </ng-container>
                </div>
              </gridster-item>
            </ng-container>
          </gridster>
        </ng-container>
        <ng-container *ngIf="getChildrenTab(item)">
          <simple-datagrid *ngIf="getChildrenTab(item)" [entityName]="getChildEntity(item).entityName" [parentRow]="getChildEntity(item).parentRow" [condition]="getChildEntity(item).condition" [child]="getChildEntity(item)"></simple-datagrid>
        </ng-container>
        <ng-container *ngIf="getCustomComponent(item)">
          <component-factory [component]="getCustomComponentReg(item)" [inputs]="customComponentdata"></component-factory>
        </ng-container>
        <ng-container  *ngIf="item.entityName=='multitable' && showMulti"  [ngTemplateOutlet]="multitable" [ngTemplateOutletContext]="{item:item}"></ng-container>
      </nz-tab>

    </nz-tabs>

    <side-panel-stepper linear="false" #stepper *ngIf="!editMode && mode=='step'" (selectionChange)="changeTab()" (onChange)="saveTabSizeDiv($event)" [sizeLeft]="sizeLeft" [sizeRight]="sizeRight">
      <side-panel-step *ngFor="let item of tabs|arrayFilter:'active':'true':false:true" [title]="item.customName|translateTA" [label]="item.customName|translateTA">
        <div class="step-wizard-main">
          <ng-container *ngIf="getCustomTab(item)">
            <gridster   [options]="getTab(item).options" [ngStyle]="editMode ? {'background':'gray','width':'100%', 'height':'100%'  } : {'width':'100%', 'height':'100%'  }">
              <ng-container *ngFor="let col of tableInformation">
                <gridster-item   [item]="col"  *ngIf="col.visible && col.tab==item.customName"  style="height: 68px;">
                  <div class="form-field-density-4 full">
                    <ng-container  #viewContainer2 dynamicField (editEventEmmiter)="eventEdit($event)" [config]="col" [group]="formGroup"  [arrayColumnsDef]="tableInformation" [isDynamicform]="false" [row]="row" [entityName]="entityName" [tabindex]="calculateTabInde(col)" [condition]="col.REFEXPRESSION" [entityDesc]="entityDesc" [canConfig]="canConfig" [evento]="evento">
                    </ng-container>
                  </div>
                </gridster-item>
              </ng-container>
            </gridster>
          </ng-container>
          <ng-container *ngIf="getChildrenTab(item)">
            <simple-datagrid   [entityName]="getChildEntity(item).entityName" [parentRow]="getChildEntity(item).parentRow" [condition]="getChildEntity(item).condition" [child]="getChildEntity(item)"></simple-datagrid>
          </ng-container>
          <ng-container *ngIf="getCustomComponent(item)">
            <component-factory [component]="getCustomComponentReg(item)" [inputs]="customComponentdata"></component-factory>
          </ng-container>
          <ng-container  *ngIf="item.entityName=='multitable' && showMulti" [ngTemplateOutlet]="multitable" [ngTemplateOutletContext]="{item:item}"></ng-container>
        </div>
      </side-panel-step>
    </side-panel-stepper>

    <div class="wizard-container" *ngIf="!editMode && mode=='wizard'">
      <nz-steps [nzCurrent]="wizardStep" nzSize="small" class="wizard-steps">
        <nz-step *ngFor="let item of tabs|arrayFilter:'active':'true':false:true" [nzTitle]="item.customName|translateTA"></nz-step>
      </nz-steps>
      <ng-container *ngFor="let item of tabs|arrayFilter:'active':'true':false:true; let i = index">
        <div class="step-wizard-main" [hidden]="wizardStep !== i">
            <ng-container *ngIf="getCustomTab(item)">
              <gridster   [options]="getTab(item).options" [ngStyle]="editMode ? {'background':'gray','width':'100%', 'height':'100%'  } : {'width':'100%', 'height':'100%'  }">
                <ng-container *ngFor="let col of tableInformation">
                  <gridster-item   [item]="col"  *ngIf="col.visible && col.tab==item.customName"  style="height: 68px;">
                    <div class="form-field-density-4 full">
                      <ng-container  #viewContainer2 dynamicField (editEventEmmiter)="eventEdit($event)" [config]="col" [group]="formGroup"  [arrayColumnsDef]="tableInformation" [isDynamicform]="false" [row]="row" [entityName]="entityName" [tabindex]="calculateTabInde(col)" [condition]="col.REFEXPRESSION" [entityDesc]="entityDesc" [canConfig]="canConfig" [evento]="evento">
                      </ng-container>
                    </div>
                  </gridster-item>
                </ng-container>
              </gridster>
            </ng-container>
            <ng-container *ngIf="getChildrenTab(item)">
              <simple-datagrid   [entityName]="getChildEntity(item).entityName" [parentRow]="getChildEntity(item).parentRow" [condition]="getChildEntity(item).condition" [child]="getChildEntity(item)"></simple-datagrid>
            </ng-container>
            <ng-container *ngIf="getCustomComponent(item)">
              <component-factory [component]="getCustomComponentReg(item)" [inputs]="customComponentdata"></component-factory>
            </ng-container>
            <ng-container  *ngIf="item.entityName=='multitable' && showMulti" [ngTemplateOutlet]="multitable" [ngTemplateOutletContext]="{item:item}"></ng-container>
        </div>
      </ng-container>
    </div>

  </div>
  <div *ngIf="editMode" class="form-configuration-main">
    <form-configuration [savingEvent]="savingLayout" [tab]="tabs" [customtab]="customtab" [nonVisibleColumns]='nonVisibleColumns'  [visibleColumns]='visibleColumns' (changing)="onChanging($event)"></form-configuration>
  </div>
  </nz-spin>

  <ng-template #multitable let-item="item">
    <div class="container">
      <div class="data-information">
        <div class="data-information-title">
          <h2> Atenção: O uso dessa tela fará com que o sistema gere registros pela quantidade de linhas do resultado abaixo.</h2>
          <nz-divider nzType="vertical"></nz-divider>
          <div class="flex-spacer"></div>
          <section class="title-multi">
            <button nz-button nzType="primary" (click)="buscarDadosMultiTable()">Buscar Dados</button>
          </section>
        </div>
        <nz-divider class="hdivider"></nz-divider>
          <div class="multi-table-container">
            <nz-spin class="multi-spin" [nzSpinning]="multiTableLoading" nzSize="large">
              <edit-form-multi-table [(dataMultiTable)]="dataMultiTable" [dataMultiTableConfig]="dataMultiTableConfig"></edit-form-multi-table>
            </nz-spin>
        </div>
      </div>
    </div>
  </ng-template>
</div>
